<template>
    <el-avatar class="u-avatar" :size="size" :src="srcUrl"></el-avatar>
</template>

<script>
import { avatarUrl, getThumbnail } from "@/utils";
export default {
    name: "Avatar",
    props: {
        src: {
            type: String,
            default: "",
        },
        size: {
            type: Number,
            default: 25,
        },
        thumbnailSize: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        srcUrl() {
            const avatar = this.src || "";
            const size = this.thumbnailSize || this.size * 2;
            if (!avatar) {
                return avatarUrl();
            }
            if (avatar.startsWith("http") || avatar.startsWith("//")) {
                return getThumbnail(avatar, size, false);
            }
            const src = avatar.startsWith("/") ? avatar : "/" + avatar;
            return getThumbnail(src, size);
        },
    },
};
</script>

<style lang="less"></style>
